/**
 * Vaccination document uploader — sub-spec 07 Plan 3 M9.
 *
 * Wraps the generic FileUploader with vaccine-document-specific URLs +
 * accept attribute. Used on both the staff PetDetail page (scope='staff')
 * and the customer PetDetail page (scope='customer').
 *
 * The component intentionally doesn't render the existing-document state
 * (View / Replace) — keep the surface minimal. Parent decides whether to
 * show a "View document" link based on the vaccination's `documentFileId`.
 */
import { FileUploader } from './FileUploader';

export interface VaccinationDocumentUploaderProps {
  scope: 'staff' | 'customer';
  petId: string;
  vaccinationId: string;
  /** Label override; defaults to "Upload record". */
  label?: string;
  onUploaded: (fileId: string) => void;
  onError?: (message: string) => void;
}

export function VaccinationDocumentUploader({
  scope,
  petId,
  vaccinationId,
  label = 'Upload record',
  onUploaded,
  onError,
}: VaccinationDocumentUploaderProps) {
  const base =
    scope === 'staff'
      ? `/api/pets/${petId}/vaccinations/${vaccinationId}/document`
      : `/api/customer/pets/${petId}/vaccinations/${vaccinationId}/document`;
  return (
    <FileUploader
      presignUrl={`${base}/presign`}
      confirmUrl={`${base}/confirm`}
      accept="application/pdf,image/jpeg,image/png"
      label={label}
      onUploaded={onUploaded}
      {...(onError ? { onError } : {})}
    />
  );
}
